import type { ProgramsProgramCohortModel } from '@efdigital/ll-admin-v2/routes/programs/program/cohort';
import Route from '@ember/routing/route';

export type ParamsCategory = {
  category: 'announcement' | 'discussion';
};

export type ProgramsProgramCohortMessagesCategoryModel =
  ProgramsProgramCohortModel & ParamsCategory;

export default class ProgramsProgramCohortMessagesCategoryRoute extends Route<ProgramsProgramCohortMessagesCategoryModel> {
  model(params: ParamsCategory) {
    const parentModel = this.modelFor(
      'programs.program.cohort'
    ) as ProgramsProgramCohortModel;

    return {
      ...parentModel,
      ...params,
    };
  }
}
